import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Load More",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-load-more",
    args: {
        alignContent: "right",
        link: false,
        targetElementSelector: "target-list",
    },
    argTypes: {
        alignContent: { control: "radio", options: ["left", "right"] },
        link: { control: "boolean" },
        targetElementSelector: { control: "text" },
    },
};

const Template = ({ link, targetElementSelector }) =>
    html` <ul class="ux-list ${targetElementSelector}">
            <li>
                Class curabitur suscipit tempus nibh dis posuere primis litora,
                phasellus ornare semper nisl himenaeos tincidunt sit auctor
                fringilla, ligula porttitor nunc netus lacus egestas aliquet.
            </li>
            <li>Litora bibendum curabitur faucibus urna</li>
            <li>
                Maximus senectus faucibus lacinia tristique dictum dapibus
                congue venenatis sed
            </li>
            <li>
                Ac luctus dis ridiculus nostra ex conubia dictum facilisi
                tristique diam habitant inceptos iaculis egestas eu euismod
                massa nunc erat
            </li>
            <li>
                Dolor vivamus ut nostra penatibus laoreet volutpat ridiculus
                adipiscing ac quisque metus facilisis ultrices lorem dis
            </li>
            <li>
                Eget ac convallis rutrum leo maecenas ultrices malesuada amet
                litora odio sed sapien dictum elit neque placerat posuere
                adipiscing vestibulum euismod
            </li>
            <link
                rel="next"
                href="mock-data/load-more-${link ? "link-" : ""}1.html"
            />
        </ul>
        ${link
            ? html`
                  <ux-iws-load-more
                      link
                      target-element-selector=".${targetElementSelector}"
                  >
                      Load more
                      <span slot="error">
                          There was an error while loading the data
                      </span>
                  </ux-iws-load-more>
              `
            : html`
                  <ux-iws-load-more
                      target-element-selector=".${targetElementSelector}"
                  >
                      Load more
                      <span slot="error">
                          There was an error while loading the data
                      </span>
                  </ux-iws-load-more>
              `}`;

export const Button = Template.bind({});

export const Link = Template.bind({});
Link.args = {
    link: true,
};
